import { makeActionCreator } from '../../utils/actionsUtils';
import { ADBLOCKER_DETECTED, COOKIES_ENABLED } from './constants';

export const registerAdBlockerDetection = makeActionCreator(ADBLOCKER_DETECTED, 'isDetected');

export const registerCookieDetection = makeActionCreator(COOKIES_ENABLED, 'isEnabled');



// WEBPACK FOOTER //
// ./src/services/adblocker/actions.js